import React from 'react';
import {useIntl} from 'react-intl';
import {useOldInspectionStatusContext} from '../OldInspectionStatusContext';
import StatusBadge from '../../../_common/components/StatusBadge';
import Divider from '../../../_common/components/Divider';
import ModalHeader from '../../../_common/components/ModalHeader';

const OldInspectionStatus = () => {
  const intl = useIntl();
  const {onChangeStatus, status, onSubmit} = useOldInspectionStatusContext();

  return Boolean(status.value) && (
    <div className={'d-flex flex-column align-items-center py-2'}>
      <ModalHeader
        header={
          intl.formatMessage({
            id: 'old-inspections-page-change-status-label',
            defaultMessage: 'Change inspection status'
          })
        }
        customClassnames={'pt-0 pb-4'}
      />
      <StatusBadge
        status={status}
        onChange={onChangeStatus}
        onSubmit={onSubmit}
        size={'lg'}
      />
      <Divider/>
    </div>
  );
};

export default OldInspectionStatus;
